import {call, put, takeEvery, takeLatest} from "redux-saga/effects"

// Login Redux States
import {
    LOGIN_USER,
    LOGOUT_USER,
    SOCIAL_LOGIN,
    DASHBOARD_SYNC,
    SOCIAL_LOGIN_TOKEN
} from "./actionTypes"
import {apiError, dashboardData, loginSuccess, logoutUserSuccess, dashboardSyncResult, socialLoginTokenResult} from "./actions"

import {
    getPermissoes,
    postJwtLogin,
    postSocialLogin,
    apiBuscarDashboardSinc,
    apiUsuariosSocialLoginToken
} from "../../../helpers/backend_helper"

function* loginUser({payload: {user, history}}) {
    try {
        const response = yield call(postJwtLogin, user)

        if (response.emailPendingValidation) {
            history.push("/verificar-email")
        } else {
            localStorage.setItem("authToken", response.token)
            localStorage.setItem("authUser", JSON.stringify(response))

            response.permissoes = yield call(getPermissoes)
            yield put(loginSuccess({ token: response.token, user: response.object, permissoes: response.permissoes, preferences: response.preferencias }))
            if (user.keepConnected) {
                localStorage.setItem("keepConnected", "true")
            } else {
                localStorage.removeItem("keepConnected")
            }

            if (response.token) {
                if (response.object.usuario_info) {
                    history.push("/dashboard-padrao")
                } else if (
                    (response.object.vinculos || []).some(vinculo =>
                        ["A", "T"].includes(vinculo.vinculo_status)
                    )
                ) {
                    history.push("/dashboard-padrao")
                } else {
                    history.push("/solicitar-vinculo")
                }
            }
        }
    } catch (error) {
        yield put(apiError(error))
    }
}

function* logoutUser({payload: {history}}) {
    try {
        localStorage.removeItem("authUser")
        localStorage.removeItem("authToken")
        localStorage.removeItem("keepConnected")
        localStorage.removeItem("keepConnectedLastRefresh")
        localStorage.removeItem("avatarUser")
        history.push("/login")
        yield put(logoutUserSuccess())
    } catch (error) {
        yield put(apiError(error))
    }
}

function* socialLogin({payload: {data, history, type}}) {
    try {
        const response = yield call(postSocialLogin, data)
        localStorage.setItem("authToken", response.token)
        localStorage.setItem("authUser", JSON.stringify(response))

        response.permissoes = yield call(getPermissoes)
        yield put(loginSuccess({ token: response.token, user: response.object, permissoes: response.permissoes, preferences: response.preferencias }))

        if (response.token) {
            if (response.object.usuario_info) {
                history.push("/dashboard-padrao")
            } else if (
                (response.object.vinculos || []).some(vinculo =>
                    ["A", "T"].includes(vinculo.vinculo_status)
                )
            ) {
                history.push("/dashboard-padrao")
            } else {
                history.push("/solicitar-vinculo")
            }
        }
    } catch (error) {
        yield put(apiError(error))
    }
}

function* buscarDashboardSync({payload}){
    try {
        const response = yield call(apiBuscarDashboardSinc, {
            company: payload.data.company,
            tabela: payload.data.tabela
        })
        yield put(dashboardSyncResult(response, payload.type))
    } catch (error) {
        yield put(dashboardSyncResult({ error: true }, payload.type))
    }
}

function* socialLoginPayload({payload: {data}}){
    try {
        const response = yield call(apiUsuariosSocialLoginToken, data)
        yield put(socialLoginTokenResult(response))
    } catch (error) {
        yield put(apiError(error))
    }
}


function* authSaga() {
    yield takeEvery(LOGIN_USER, loginUser)
    yield takeLatest(SOCIAL_LOGIN, socialLogin)
    yield takeEvery(LOGOUT_USER, logoutUser)
    yield takeEvery(DASHBOARD_SYNC, buscarDashboardSync)
    yield takeLatest(SOCIAL_LOGIN_TOKEN, socialLoginPayload)
}

export default authSaga
